/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_SpacerInputs */

const cs_builder_block_spacer = /** @type {(inputs: Builder_Block_SpacerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mezera`)
};

const en_builder_block_spacer = /** @type {(inputs: Builder_Block_SpacerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spacer`)
};

/**
* | output |
* | --- |
* | "Spacer" |
*
* @param {Builder_Block_SpacerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_spacer = /** @type {((inputs?: Builder_Block_SpacerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_SpacerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_spacer(inputs)
	return cs_builder_block_spacer(inputs)
});